import React, { useState, useEffect } from 'react';
import { collection, onSnapshot, query, orderBy, where } from 'firebase/firestore';
import { db } from '../../../core/services/firebase/config';
import { StatsOverview, StatItem } from '../components/dashboard/StatsOverview';
import { TenantRequestList, TenantRequest } from '../components/dashboard/TenantRequestList';
import { Users, Building2, Ticket, CheckCircle, Clock } from 'lucide-react';
import { Link } from 'react-router-dom';

export const AdminDashboardPage: React.FC = () => {
  const [stats, setStats] = useState<StatItem[]>([
    { id: '1', label: 'Total de Usuários', value: '-', change: '...', trend: 'neutral', icon: Users, color: 'blue' },
    { id: '2', label: 'Empresas Ativas', value: '-', change: '...', trend: 'neutral', icon: Building2, color: 'green' },
    { id: '3', label: 'Solicitações Pendentes', value: '-', change: '...', trend: 'neutral', icon: Ticket, color: 'yellow' },
    // { id: '4', label: 'Receita (Est)', value: 'R$ 0', change: '0%', trend: 'neutral', icon: TrendingUp, color: 'purple' },
  ]);
  
  const [requests, setRequests] = useState<TenantRequest[]>([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    // 1. Listen to Users
    const usersUnsub = onSnapshot(collection(db, 'users'), (snapshot) => {
       const count = snapshot.size;
       updateStat('1', count.toString(), '+Live');
    });

    // 2. Listen to Tenants
    const tenantsQuery = query(collection(db, 'tenants'), orderBy('createdAt', 'desc'));
    const tenantsUnsub = onSnapshot(tenantsQuery, (snapshot) => {
       const allTenants = snapshot.docs.map(doc => ({ id: doc.id, ...doc.data() }));
       
       // Stats
       const activeCount = allTenants.filter((t: any) => t.verified).length;
       const pendingCount = allTenants.filter((t: any) => !t.verified).length;
       
       updateStat('2', activeCount.toString(), 'Verificadas');
       updateStat('3', pendingCount.toString(), 'Aguardando');

       // Requests List (Pending or recent)
       // We map tenants to the request format. For existing tenants, we assume they are "requests" if !verified
       const pendingRequests = allTenants
         .filter((t: any) => !t.verified)
         .map((t: any) => ({
            id: t.id,
            businessName: t.businessName || 'Sem Nome',
            category: t.category || 'Empresa',
            city: t.address?.city || 'Brasil',
            state: t.address?.state || 'BR',
            requestDate: formatDate(t.createdAt),
            status: 'pending',
            contactName: 'Ver Detalhes', // Would need helper to fetch owner
            email: '...' // Would need helper
         })) as TenantRequest[];

       setRequests(pendingRequests);
       setLoading(false);
    });

    return () => {
      usersUnsub();
      tenantsUnsub();
    };
  }, []);

  const updateStat = (id: string, value: string, change: string) => {
    setStats(prev => prev.map(s => s.id === id ? { ...s, value, change } : s));
  };

  const formatDate = (timestamp: any) => {
      if (!timestamp) return 'Hoje';
      const date = timestamp.toDate ? timestamp.toDate() : new Date(timestamp);
      return new Intl.DateTimeFormat('pt-BR', { day: '2-digit', month: '2-digit' }).format(date);
  };

  const handleAction = (id: string, action: string) => {
    console.log(`Action ${action} on request ${id}`);
  };

  return (
    <div className="space-y-6">
      <div className="flex flex-col sm:flex-row sm:items-center justify-between gap-4 mb-6">
        <div>
           {/* Header handled by Layout */}
        </div>
        <Link to="/admin/tenants" className="px-4 py-2 bg-blue-600 hover:bg-blue-700 text-white text-sm font-medium rounded-lg transition-colors shadow-sm self-end flex items-center gap-2">
            <Building2 size={16} />
            Gerenciar Empresas
        </Link>
      </div>

      <StatsOverview stats={stats} />
      
      <div className="grid grid-cols-1 lg:grid-cols-3 gap-6">
          <div className="lg:col-span-3">
             <TenantRequestList 
                requests={requests} 
                onAction={handleAction}
             />
          </div>
      </div>
    </div>
  );
};
